import React, { useEffect } from 'react'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import { useDispatch, useSelector } from 'react-redux';
import { getCmsData } from '../../../Redux/action/MasterAction';
import parse from 'html-react-parser'
import FeedbackForm from '../../FeedbackForm/FeedbackForm';

const PrivacyPolicy = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getCmsData());
    }, [])

    const {
        loadingCmsDataListApi,
        CmsDataListApiData,
        CmsDataListApiError
    } = useSelector(state => state?.MasterReducer);

    // console.log(CmsDataListApiData?.[2]?.description)

    return (
        <div>
            <Header />
            <FeedbackForm />
            <section className="blogs">
                <div className="container">
                    <div className="content" style={{ transform: "none", minHeight: 24, zIndex: "99", position: 'relative' }}>
                        <div className="container-fluid home-slide-text-new " style={{ transform: "none" }}>
                            <h1 className='text-center'>Privacy Policy</h1>
                            {CmsDataListApiData?.[1]?.description ? parse(CmsDataListApiData?.[1]?.description) : ''}
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default PrivacyPolicy